<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle" style="margin-top: 10px; margin-bottom: 5px">
            <el-breadcrumb-item :to="{ path: '/flowConfig01List' }">流向商业配置</el-breadcrumb-item>
            <el-breadcrumb-item>批量设置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <vSearchSelect
                    model_key="supplier_rid"
                    model_name="请输入供方搜索"
                    request_uri="searchAccounts"
                    default_option_key="supplier_option"
                    :default_option="queryParams['supplier_option']"
                    @onDropChange="onDropChange"
                    ref="supplier_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item">
                <vSearchSelect
                    model_key="sup_supplier_rid"
                    model_name="请输入上级供方搜索"
                    request_uri="searchAccounts"
                    default_option_key="sup_supplier_option"
                    :default_option="queryParams['sup_supplier_option']"
                    @onDropChange="onDropChange"
                    ref="sup_supplier_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="province_rid"
                    model_name="请选择省份"
                    :model_value_default="queryParams['province_rid']"
                    request_uri="provinces"
                    @onDropChange="onDropChange"
                    ref="province_rid_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="batchSave" :loading="save_loading">批量设置</el-button>
                <!-- <el-button size="small" plain @click="match" :loading="save_loading">匹配流向</el-button> -->
                <span style="color: red; font-size: 13px">
                    &nbsp;&nbsp;&nbsp;&nbsp;注意：批量设置后请点击匹配流向按钮进行刷新。批量设置只对当前分页有效，请勿跨分页操作</span
                >
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="commodity_flow_business"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <el-table-column label="一级商业" width="260">
                    <template slot-scope="scope" style="height: 100%">
                        <vSearchSelect
                            style="width: 100%"
                            :model_key="scope.row['rid']"
                            model_name="请输入一级商业搜索"
                            request_uri="searchAccounts"
                            :default_option_key="'option_' + scope.row['rid']"
                            :default_option="formData['option_' + scope.row['rid']] || ''"
                            @onDropChange="onDropChange1"
                        ></vSearchSelect>
                    </template>
                </el-table-column>

                <el-table-column label="合作方" width="260">
                    <template slot-scope="scope" style="height: 100%">
                        <vSearchSelect
                            style="width: 100%"
                            :model_key="scope.row['rid']"
                            model_name="请输入合作方搜索"
                            request_uri="searchPartners"
                            :default_option_key="'option1_' + scope.row['rid']"
                            :default_option="formData['option1_' + scope.row['rid']] || ''"
                            @onDropChange="onDropChange1"
                        ></vSearchSelect>
                    </template>
                </el-table-column>

                <el-table-column label="日期" width="340">
                    <template slot-scope="scope" style="height: 100%">
                        <el-input
                            v-model="formData['startdate_' + scope.row['rid']]"
                            placeholder="示例：2024-01-01"
                            clearable
                            style="width: 150px"
                        ></el-input>
                        -
                        <el-input
                            v-model="formData['enddate_' + scope.row['rid']]"
                            placeholder="示例：2024-12-31"
                            clearable
                            style="width: 150px"
                        ></el-input>
                    </template>
                </el-table-column>

                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['xxx'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>

                <!-- <el-table-column label="操作" width="80">
                    <template slot-scope="scope" style="height: 100%">
                        <el-tooltip class="item" effect="dark" content="保存" placement="top-start">
                            <i class="el-icon-s-claim" @click="save(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect
    },
    name: 'flowConfig01FlowListComponent',
    data() {
        return {
            draggable: {
                data_name: 'commodity_flow_business'
            },
            save_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            queryParams: {},
            partnerDropData: [],
            formData: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
        this.initPartnerDropData();
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    beforeDestroy() {
        this.partnerDropData = null;
        this.tableData = null;
        this.formData = null;
        this.draggable = null;
        this.colData = null;
    },
    methods: {
        in_array,
        initPartnerDropData() {
            this.$api['dropdownPartners']({})
                .then((res) => {
                    this.partnerDropData = [];
                    res.data.forEach((item) => {
                        this.partnerDropData.push({
                            value: item['rid'],
                            label: item['name']
                        });
                    });
                })
                .catch((error) => {});
        },
        //跳转详情
        toDetail(row, prop) {},
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        onDropChange1(key, value) {
            if (String(value).indexOf('ACCT') != -1) {
                this.formData['business_' + key] = value;
            } else {
                this.formData['partner_' + key] = value;
            }
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('commodity_flow_business_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('commodity_flow_business_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_flow_business', this, 3);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_flow_business;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'commodityFlowConfig01FlowLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        // 保存
        save(row) {},
        // 批量保存
        batchSave() {
            this.save_loading = true;
            var saveData = {
                data: []
            };
            var temp = {};
            for (let key in this.formData) {
                if (this.formData.hasOwnProperty(key)) {
                    if (key.indexOf('business_CMFL') != -1) {
                        let rid = key.split('_')[1];
                        if (temp[rid]) {
                            temp[rid]['business_rid'] = this.formData[key];
                        } else {
                            temp[rid] = {
                                business_rid: this.formData[key]
                            };
                        }
                    } else if (key.indexOf('partner_CMFL') != -1) {
                        let rid = key.split('_')[1];
                        if (temp[rid]) {
                            temp[rid]['partner_rid'] = this.formData[key];
                        } else {
                            temp[rid] = {
                                partner_rid: this.formData[key]
                            };
                        }
                    } else if (key.indexOf('startdate_CMFL') != -1) {
                        let rid = key.split('_')[1];
                        if (temp[rid]) {
                            temp[rid]['start_date'] = this.formData[key];
                        } else {
                            temp[rid] = {
                                start_date: this.formData[key]
                            };
                        }
                    } else if (key.indexOf('enddate_CMFL') != -1) {
                        let rid = key.split('_')[1];
                        if (temp[rid]) {
                            temp[rid]['end_date'] = this.formData[key];
                        } else {
                            temp[rid] = {
                                end_date: this.formData[key]
                            };
                        }
                    }
                }
            }

            // 'business_rid', 'partner_rid', 'start_date', 'end_date', 'supplier_rid','sup_supplier_rid', 'product_rid', 'credential_rid'
            this.tableData.forEach((item) => {
                if (
                    temp[item.rid] &&
                    temp[item.rid]['business_rid'] &&
                    temp[item.rid]['partner_rid'] &&
                    temp[item.rid]['start_date'] &&
                    temp[item.rid]['end_date']
                ) {
                    temp[item.rid]['supplier_rid'] = item['supplier_rid'];
                    temp[item.rid]['sup_supplier_rid'] = item['sup_supplier_rid'];
                    temp[item.rid]['product_rid'] = item['product_rid'];
                    temp[item.rid]['credential_rid'] = item['source_credential_rid'];
                    saveData['data'].push(temp[item.rid]);
                }
            });

            if (saveData['data'].length == 0) {
                this.save_loading = false;
                this.$message.error('没有需要更新的数据');
                return false;
            }

            this.$api['commodityFlowConfig01BatchInsert'](saveData)
                .then((res) => {
                    this.save_loading = false;
                    if (res.code == 0) {
                        this.$message.success('更新成功');
                    }
                    this.reload();
                })
                .catch((error) => {
                    this.save_loading = false;
                });
        },
        match() {
            this.$confirm('您确定要匹配流向吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['commodityFlowConfig01Match']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        reset() {
            this.initQueryParams();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
</style>